import * as React from 'react';
import * as styles from './LocationPickerDropdown.css';
import { ISuggestion } from '../../types';

interface ILocationPickerDropdownProps {
  suggestions: ISuggestion[];
  onSelect(locationId: number): void;
}

export const LocationPickerDropdown = React.forwardRef<HTMLDivElement, ILocationPickerDropdownProps>(
  function LocationPickerDropdown({ suggestions, onSelect }, ref) {
    return (
      <div ref={ref} data-name="LocationPickerDropdown" className={styles['container']}>
        {suggestions.length ? (
          <ul role="listbox" className={styles['list']}>
            {suggestions.map(({ id, match, prefix, suffix }) => (
              <li role="option" key={id} className={styles['item']} onClick={() => onSelect(id)}>
                <span>
                  {prefix}
                  <strong>{match}</strong>
                  {suffix}
                </span>
              </li>
            ))}
          </ul>
        ) : (
          <div className={styles['empty']}>
            У нас ещё нет строительных компаний в этом регионе,
            <br />
            попробуйте поискать в соседних
          </div>
        )}
      </div>
    );
  },
);
